import React, { FC, useState } from 'react'
import { Column, Row } from 'react-table'
import Table from '../../components/Table';
import { Avatar, Container, Dialog, DialogTitle, Grid, List, ListItem, ListItemAvatar, ListItemText, makeStyles, Typography } from '@material-ui/core';
import { DeviceOverview, DeviceOverviewData } from '../../api/mobilbase/models';
import { AllInbox, Build } from '@material-ui/icons';
import * as mobilbase from '../../api/mobilbase';
import { useLocation } from 'react-router-dom';
import { RouteLocationProps } from '../../routes/mobilbase';
import NoDataDialog from '../../components/dialogs/ErrorDialog';
import APIRequest from '../../components/helpers/APIRequest';

const useStyles = makeStyles((theme) => ({
    paper: {
      marginTop: theme.spacing(3),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    grid: {
      width: '100%', // Fix IE 11 issue.
      marginTop: theme.spacing(3),
    },
}));

interface Props {
  navFunc: ((historyState: RouteLocationProps) => void)
}

const DeviceOverviewPage: FC<Props> = ({ navFunc }) => {
  const classes = useStyles();
  const routeLocation = useLocation<RouteLocationProps>();
  const {selectedLocationId, selectedLocationName} = (routeLocation.state) ? routeLocation.state : new RouteLocationProps();
  const [data, setData] = useState<DeviceOverview>({elements: [], locationName: ""});
  const [isPending, setIsPending] = useState(false);
  const [run, setRun] = useState(true);
  const [selectedDeviceId, setSelectedDeviceId] = useState(0);
  const [selectedDeviceName, setSelectedDeviceName] = useState('');
  const [open, setOpen] = React.useState(false);
  const [offlineOpen, setOfflineOpen] = React.useState(false);

  const handleChange = (element: DeviceOverviewData) => {
    if (element.power === '-' && element.door === '-' && element.inUse === '-' && element.printer === '-' && element.card === '-' && element.coin === '-' && element.display === '-') {
      setOfflineOpen(true);
      return;
    }
    setSelectedDeviceId(element.deviceID);
    setSelectedDeviceName(element.name);
    setOpen(true);
  };

  const handleClose = (value: string) => {
    setOpen(false);
    if (value === "log") {
      navFunc(new RouteLocationProps(3, selectedLocationId, selectedLocationName, selectedDeviceId, selectedDeviceName));
    } else if (value === "manage") {
      navFunc(new RouteLocationProps(4, selectedLocationId, selectedLocationName, selectedDeviceId, selectedDeviceName))
    }
  };

  const handleCloseOffline = () => {
    setOfflineOpen(false);
  };

  const columns: Column<DeviceOverviewData>[] = React.useMemo(
    () => [
      { Header: 'Automat nummer', id: "0", accessor: 'deviceID'},
      { Header: 'Automat navn', id: "1", accessor: 'name'},
      { Header: '220V', id: "2", accessor: 'power'},
      { Header: 'Dør', id: "3", accessor: 'door'},
      { Header: 'I drift', id: "4", accessor: 'inUse'},
      { Header: 'Printer', id: "5", accessor: 'printer'},
      { Header: 'Kort', id: "6", accessor: 'card'},
      { Header: 'Mønt', id: "7", accessor: 'coin'},
      { Header: 'Papirstatus', id: "8", accessor: 'paperStatus'},
      { Header: 'Display', id: "9", accessor: 'display'},
      { Header: 'Kort trans.', id: "10", accessor: 'lastCard',
        sortType: (rowA: Row<DeviceOverviewData>, rowB: Row<DeviceOverviewData>) => {
          if (rowA.values.lastCard !== undefined && rowB.values.lastCard !== undefined) {
            const a = rowA.values.lastCard.split(/-|:| /);
            const b = rowB.values.lastCard.split(/-|:| /);
            return ((a[2] + a[1] + a[0] + a[3] + a[4] + a[5]) < (b[2] + b[1] + b[0] + b[3] + b[4] + b[5])) ? -1 : 1
          }
          else{
            return -1
          }
        }
      },
      { Header: 'Mønt trans.', id: "11", accessor: 'lastCoin',
        sortType: (rowA: Row<DeviceOverviewData>, rowB: Row<DeviceOverviewData>) => {
          if (rowA.values.lastCoin !== undefined && rowB.values.lastCoin !== undefined) {
            const a = rowA.values.lastCoin.split(/-|:| /);
            const b = rowB.values.lastCoin.split(/-|:| /);
            return ((a[2] + a[1] + a[0] + a[3] + a[4] + a[5]) < (b[2] + b[1] + b[0] + b[3] + b[4] + b[5])) ? -1 : 1
          }
          else{
            return -1
          }
          }
      },
      { Header: 'Møntboks', id: "12", accessor: 'coinbox'},
      { Header: 'Printtæller', id: "13", accessor: 'printerCount'},
    ],
    []
  );

  function customCellStyle <T extends object>(columns: Column<T>[], index: number, value: any) {
    return {
      background: (
        (columns[index].accessor?.toString() === "power" && value === "Fejl") ||
        (columns[index].accessor?.toString() === "door" && value === "Fejl") ||
        (columns[index].accessor?.toString() === "inUse" && value === "Fejl") ||
        (columns[index].accessor?.toString() === "printer" && value === "Fejl") ||
        (columns[index].accessor?.toString() === "card" && value === "Fejl") ||
        (columns[index].accessor?.toString() === "coin" && value === "Fejl") ||
        (columns[index].accessor?.toString() === "display" && value === "Fejl") ||
        (columns[index].accessor?.toString() === "paperStatus" && value === "Fejl")
      ) ? "rgba(255, 0, 0, 0.3)" : ""
    }
  }

  const RequestData = () => {
    return (
      <APIRequest<DeviceOverview> 
          run={run} 
          setRun={setRun}
          pending={isPending}
          setIsPending={setIsPending} 
          req={() => mobilbase.getDeviceOverview({locationId: selectedLocationId})}
          setData={setData}
      />
    );
  }
  return (
    <Container maxWidth={false}>
      <RequestData/>
        <div className={classes.paper}>
            <Typography component="h1" variant="h5">
                Automatoversigt - {((selectedLocationName) ? selectedLocationName : "INGEN VALGT")}
            </Typography>
        <div className={classes.grid}>
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Table<DeviceOverviewData> 
                  columns={columns} 
                  data={mapDeviceOverviewData(data)} 
                  initialState={{pageSize: 150}} 
                  clickEvent={handleChange} 
                  update={() => {setRun(true)}} 
                  pending={isPending}  
                  text={""}
                  customCellStyle={customCellStyle}
                />
            </Grid>
          </Grid>
        </div>
      </div>
        <SimpleDialog open={open} onClose={handleClose} />
        <NoDataDialog open={offlineOpen} onClose={handleCloseOffline} title={"Hov..."} text={"Denne automat er offline, så denne handling er ikke mulig"}/>
    </Container>      
  );
}

interface SimpleDialogProps {
    open: boolean;
    //selectedValue: string;
    onClose: (value: string) => void;
}

const SimpleDialog: FC<SimpleDialogProps> = ({ onClose, open }) => {
  
    const handleClose = () => {
      onClose("");
    };
  
    const handleListItemClick = (value: string) => {
      onClose(value);
    };
  
    return (
      <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open}>
        <DialogTitle id="simple-dialog-title">Vælg handling</DialogTitle>
        <List>
          <ListItem autoFocus button onClick={() => handleListItemClick('log')}>
            <ListItemAvatar>
              <Avatar>
                <AllInbox />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary="Hændelseslog" />
          </ListItem>
          <ListItem autoFocus button onClick={() => handleListItemClick('manage')}>
            <ListItemAvatar>
              <Avatar>
                <Build />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary="Administrer" />
          </ListItem>
        </List>
      </Dialog>
    );
  }

export default DeviceOverviewPage;

export const mapDeviceOverviewData = (data: DeviceOverview | undefined) => {
  if (!data || !data.elements) {
    return []
  }
    return data.elements.map(d => {
      var l = {...d}  
      l.coinbox = (l.coinbox === -1) ? "-" : l.coinbox;
      l.printerCount = (l.printerCount === -1) ? "-" : l.printerCount;
      return l;
    });
}